import { version as APP_VERSION } from "../../package.json";

const APP_SHORT_NAME = "ParlaEditor";

const TRANSLATIONS_EXPORT_API_URL = "https://dijetbunvxszevyhqsrl.supabase.co/functions/v1/translations";

const TRANSLATIONS_EXPORT_API_TOKEN = "cFybGFlZGl0b3IuY2tLWFuZGV5yc29uCLWlu61aXRpYWwtdG9rZW4";

const IS_DEV_ENV = window.location.href.includes("http://localhost");

const IS_CYPRESS_ENV = Boolean((window as any)?.Cypress);

const SENTRY_DNS = "https://9d8a927a0242f54aaa97c9bf3c6e44ec@o284519.ingest.us.sentry.io/4511231245025281";

const GA_MEASUREMENT_ID = "G-WRY7EV6H6M";

const DEFAULT_SELECT_LIMIT = 100;

const SETTINGS = {
  testSetting: true,
};

export {
  APP_SHORT_NAME,
  APP_VERSION,
  IS_DEV_ENV,
  IS_CYPRESS_ENV,
  SENTRY_DNS,
  GA_MEASUREMENT_ID,
  DEFAULT_SELECT_LIMIT,
  SETTINGS,
  TRANSLATIONS_EXPORT_API_URL,
  TRANSLATIONS_EXPORT_API_TOKEN,
};
